<!--
 * @FileDescription: 单据——采购入库详情
 * @Author: ryb
 * @Date: 2020-07-22
 -->
<template>
  <div class="bill-purchase-page">
    <div class="bill-purchase-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col :span="12">
          <span class="a-col-title" v-if="dataDetails.reverseFlag==1">红冲原因：</span>
          <span class="a-col-value" v-if="dataDetails.reverseFlag==1">{{ dataDetails.reverseReason }}</span>
        </a-col>
        <a-col style="display:flex;justify-content: flex-end;" :span="12">
          <a-col>
            <span class="a-col-title">单据单号：</span>
            <span class="a-col-value"> {{ dataDetails.inboundCode }}</span>
          </a-col>
          <a-col style="margin-left: 106px">
            <span class="a-col-title">单据日期：</span>
            <span class="a-col-value">{{ dataDetails.inboundDate }}</span>
          </a-col>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">往来单位：</span>
          <span class="a-col-value">{{ dataDetails.contactCustomerName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">入库仓库：</span>
          <span class="a-col-value"> {{ dataDetails.storageName }}</span>
        </a-col>
        <a-col v-if="dataDetails.transactorName">
          <span class="a-col-title">经办人：</span>
          <span class="a-col-value"> {{ dataDetails.transactorName }}</span>
        </a-col>
        <a-col v-if="dataDetails.digest">
          <span class="a-col-title">摘要：</span>
          <span class="a-col-value">{{ dataDetails.digest }}</span>
        </a-col>
        <a-col v-if="dataDetails.remark">
          <span class="a-col-title">备注：</span>
          <span class="a-col-value">{{ dataDetails.remark }}</span>
        </a-col>
        <a-col>
          <look-popover :type="5" :dataDetails="dataDetails">
            <!-- <a-button class="border-color" slot="trigger-tag">更多
              <a-icon type="right-circle" />
            </a-button> -->
            <span class="border-color" slot="trigger-tag">
              更多
              <a-icon type="right-circle" style="margin-left: 3px" />
            </span>
          </look-popover>
        </a-col>
      </a-row>
    </div>

    <div class="bill-purchase-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataDetails.itemList" :pagination="false" rowKey="id"
        :scroll="{ y: (tableHeight) }" bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{ index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="productCode" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品备注 -->
        <template slot="remark" slot-scope="text" v-if="text">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 底部合计 -->
        <template slot="footer">
          <div class="footer-total-amount">
            <div class="footer-total-amount-left" style="width: 80px">
              <span class="title">小计</span>
            </div>
            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
              <span class="right-col">入库数量：{{ footerDataSource[0].productCount }}</span>
              <span class="right-col">金额：{{ footerDataSource[0].totalAmount.toFixed(2) }}</span>
            </div>
          </div>
        </template>
      </a-table>
    </div>

    <div class="bill-purchase-price" id="page-button">
      <div class="logistics-information">
        <!-- <a-row>
          <a-col>
            <span class="a-col-title">物流方式：</span>
            <span class="a-col-value">{{ dataDetails.distributionMode==1?'客户自提' :'送货上门' }}</span>
          </a-col>
        </a-row> -->
        <a-row>
          <a-col>
            <span class="a-col-title">是否包含运费：</span>
            <span class="a-col-value">{{ dataDetails.includeFreightFlag==0?'不包括运费' :'包含运费' }}</span>
          </a-col>
        </a-row>
        <!-- <a-row v-if="dataDetails.distributionMode==2">
          <a-col>
            <span class="a-col-title">物流公司：</span>
            <span class="a-col-value">{{ dataDetails.logisticsCompanyName }}</span>
          </a-col>
          <a-col>
            <span class="a-col-title">物流单号：</span>
            <span class="a-col-value">{{ dataDetails.trackingNumber }}</span>
          </a-col>
        </a-row> -->
      </div>
      <div class="price-information">
        <a-row>
          <a-col>
            <span class="price-title">加付费用：</span>
            <span class="price-color">¥ {{ dataDetails.otherExpensesAmount? dataDetails.otherExpensesAmount :0 }}</span>
            <!-- <lookPopover :type="1" :dataDetails="dataDetails">
              <span style="color:#387BFC;margin-left:10px;cursor: pointer;" slot="trigger-tag">查看</span>
            </lookPopover> -->
          </a-col>
          <a-col>
            <span class="price-title">优惠金额：</span>
            <span class="price-color">¥ {{ dataDetails.discountAmount? dataDetails.discountAmount :0 }}</span>
          </a-col>
          <a-col>
            <span class="price-title">本次应付：</span>
            <span class="price-color">¥ <span style="font-size: 40px">{{ dataDetails.totalAmount }}</span></span>
          </a-col>
        </a-row>
        <a-row>
          <a-col style="margin-left: 26px">
            <span class="price-title">付款账户和金额：</span>
            <span style="margin-right:15px">{{ accountsName }}</span>
            <span class="price-color">¥ {{ dataDetails.paymentAmount? dataDetails.paymentAmount :0 }}</span>
            <lookPopover :type="2" :dataDetails="dataDetails">
              <span style="color:#387BFC;margin-left:10px;cursor: pointer;" slot="trigger-tag">查看</span>
            </lookPopover>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 底部按钮组件 -->
    <public-footer :buttonList="buttonList" @onClickButton="onClickButton" @onConfirmOrder="onConfirmOrder"
      @onConfirmRedDash="onConfirmRedDash" @confirmDeletion="onDeleteOrder" @btnOkSave="btnOkSave"></public-footer>
    <relevance-order ref="relevanceorder"></relevance-order>
  </div>
</template>
<script>
import pick from "lodash.pick";
import publicFooter from "@/components/module/publicFooter.vue";
import relevanceOrder from "@/components/module/relevanceOrder.vue";
import lookPopover from "./lookPopover.vue";
import { tableWidth } from "@/mixins/tableWidth";
import {
  getBillDetails,
  inboundflush,
  operatePass,
  updateauditState,
  abandonstate,
} from "@/utils/api";
export default {
  name: "billPurchase",
  mixins: [tableWidth],
  components: {
    publicFooter,
    relevanceOrder,
    lookPopover,
  },
  data() {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 180,
          title: "商品名称",
          dataIndex: "productName",
          ellipsis: true,
          scopedSlots: { customRender: "productName" },
        },
        {
          defaultWidth: 180,
          title: "商品编号",
          dataIndex: "productCode",
          ellipsis: true,
          scopedSlots: { customRender: "productCode" },
        },
        {
          title: "规格",
          ellipsis: true,
          dataIndex: "productSpecification",
        },
        {
          title: "型号",
          ellipsis: true,
          dataIndex: "productModel",
        },
        {
          defaultWidth: 80,
          title: "单位",
          dataIndex: "productUnit",
          ellipsis: true,
        },
        {
          title: "数量",
          align: "right",
          dataIndex: "productCount",
          ellipsis: true,
        },
        {
          title: "单价",
          align: "right",
          dataIndex: "price",
          ellipsis: true,
        },
        {
          title: "金额",
          align: "right",
          ellipsis: true,
          dataIndex: "totalAmount",
        },
        {
          defaultWidth: 130,
          title: "入库库位",
          ellipsis: true,
          dataIndex: "locationName",
        },
        {
          defaultWidth: 160,
          title: "备注",
          dataIndex: "remark",
          ellipsis: true,
          scopedSlots: { customRender: "remark" },
        },
      ],
      dataSource: [],
      buttonList: [
        {
          id: 4,
          has: "purchase_inbound_associated_order",
          text: "查看关联单",
        },
        {
          id: 7,
          has: "purchase_inbound_order_print",
          text: "打印",
          templateType: 201,
        },
        {
          id: 5,
          text: "红冲",
          has:'purchase_inbound_red_dashed',
          class: "ant-btn-color",
        },
      ],
      footerDataSource: [
        {
          serialNum: "",
          productName: "",
          productCode: "",
          productSpecification: "",
          productModel: "",
          productUnit: "",
          productCount: 0,
          price: "",
          totalAmount: 0,
          locationName: "",
          remark: "",
        },
      ],
      contentHeight: "",
      tableHeight: "",
      urlList: {
        details: "/storage/api/inbound/findInboundById",
      },
      btnIndex: null,
      accountsName: null,
      dataDetails: {},
      billId: null,
      queryObj: {},
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.queryObj = to.query;
    this.getBillDetails();
    this.init();
    next();
  },
  activated() {
    // 表格高度计算
    let _that = this;
    setTimeout(function () {
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      let makeButton = document.getElementById("page-button").offsetHeight;
      _that.contentHeight =
        pageHeight -
        makeTop -
        makeButton -
        header -
        breadcrumb -
        tdHeight * 1.24;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
    }, 50);
    this.queryObj = this.$route.query;
    this.getBillDetails();
    this.init();
  },
  methods: {
    init() {
      if (this.queryObj.queryType && this.queryObj.queryType == 2) {
        if (this.queryObj.approvalState == 0) {
          this.buttonList = [
            {
              id: 4,
              has: "purchase_inbound_associated_order",
              text: "查看关联单",
            },
            {
              id: 23,
              text: "撤回编辑",
            },
            {
              id: 7,
              has: "purchase_inbound_order_print",
              text: "打印",
              templateType: 201,
            },
          ];
        } else if (this.queryObj.approvalState == 2) {
          this.buttonList = [
            {
              id: 4,
              has: "purchase_inbound_associated_order",
              text: "查看关联单",
            },
            {
              id: 22,
              text: "再次申请",
            },
            {
              id: 23,
              text: "撤销为草稿",
            },
            {
              id: 7,
              has: "purchase_inbound_order_print",
              text: "打印",
              templateType: 201,
            },
          ];
        } else if (this.queryObj.approvalState == 3) {
          this.buttonList = [
            {
              id: 4,
              has: "purchase_inbound_associated_order",
              text: "查看关联单",
            },
            {
              id: 7,
              has: "purchase_inbound_order_print",
              text: "打印",
              templateType: 201,
            },
          ];
        } else if (this.queryObj.approvalState == 1) {
          this.buttonList = [
            {
              id: 4,
              has: "purchase_inbound_associated_order",
              text: "查看关联单",
            },
            {
              id: 7,
              has: "purchase_inbound_order_print",
              text: "打印",
              templateType: 201,
            },
          ];
        }
      } else if (this.queryObj.queryType == 1) {
        this.buttonList = [
          {
            id: 4,
            has: "purchase_inbound_associated_order",
            text: "查看关联单",
          },
          {
            id: 20,
            text: "审核通过",
          },
          {
            id: 21,
            text: "不通过",
          },
          {
            id: 7,
            has: "purchase_inbound_order_print",
            text: "打印",
            templateType: 201,
          },
        ];
      } else if (this.queryObj.queryType == 3) {
        this.buttonList = [
          {
            id: 4,
            has: "purchase_inbound_associated_order",
            text: "查看关联单",
          },
          {
            id: 7,
            has: "purchase_inbound_order_print",
            text: "打印",
            templateType: 201,
          },
        ];
      }
      if (this.queryObj.orderType == 1) {
        this.buttonList = [
          {
            id: 7,
            has: "purchase_inbound_order_print",
            text: "打印",
            templateType: 201,
          },
        ];
      } else if (this.queryObj.orderType == 2) {
        this.buttonList = [
          {
            id: 4,
            has: "purchase_inbound_associated_order",
            text: "查看关联单",
          },
          {
            id: 7,
            has: "purchase_inbound_order_print",
            text: "打印",
            templateType: 201,
          },
          {
            id: 5,
            text: "红冲",
            has:'purchase_inbound_red_dashed',
            class: "ant-btn-color",
          },
        ];
      }
    },
    getBillDetails() {
      let url = this.urlList.details;
      let header = {};
      let params = {};
      let data = {
        id: this.queryObj.voucherEntityId,
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      this.$store.state.isLoding = true;
      getBillDetails(url, params, header, data).then((res) => {
        if (res.code == 200) {
          this.dataDetails = res.result;
          this.dataSource = res.result.itemList;
          if (this.dataDetails.paymentAccountVOList) {
            if (this.dataDetails.paymentAccountVOList.length > 1) {
              this.accountsName = "多账户";
            } else if (this.dataDetails.paymentAccountVOList.length > 1) {
              this.accountsName = this.dataDetails.paymentAccountVOList[0].financeAccountName;
            }
          }
          if (this.dataDetails.reverseFlag == 1) {
            this.buttonList.splice(2, 1);
          }
          this.footerDataSource[0].productCount = 0;
          this.footerDataSource[0].totalAmount = 0;
          this.dataSource.map((item) => {
            this.footerDataSource[0].productCount += item.productCount;
            this.footerDataSource[0].totalAmount += item.totalAmount;
          });
          this.$store.state.isLoding = false;
        } else {
          this.$message.warn(res.logMessage);
        }
      });
    },
    // 查看关联单
    onClickButton(item) {
      if (item.id == 4) {
        this.$refs.relevanceorder.open(this.dataDetails.id, 1);
      }
      this.btnIndex = item.id;
    },
    // 测试入库详情设置红冲
    onConfirmRedDash(value) {
      // 测试入库详情设置红冲
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        id: this.dataDetails.id,
        reverseReason: value,
      };
      let params = {};
      let header = {};
      this.$store.state.isLoding = true;
      inboundflush(params, header, data).then((res) => {
        if (res.code == 200) {
          this.$message.success("设置红冲成功");
          this.getBillDetails();
          this.$store.state.isLoding = false;
        } else {
          this.$message.warn(res.logMessage);
        }
      });
    },
    // 审批通过并过账
    onConfirmOrder(value) {
      if (this.btnIndex == 20) {
        let params = {
          operationData: value,
          code: this.dataDetails.inboundCode,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          operationType: 1,
          voucherId: this.queryObj.id,
          voucherType: 1,
        };
        this.$store.state.isLoding = true;
        operatePass(params).then((res) => {
          if (res.code == 200) {
            this.$message.success("审核通过");
            // this.getBillDetails()
            this.$store.state.isLoding = false;
            this.$store.state.closePath = this.$route.fullPath;
          } else {
            this.$message.warn(res.logMessage);
          }
        });
      } else if (this.btnIndex == 21) {
        let params = {
          operationData: value,
          code: this.dataDetails.inboundCode,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          operationType: 2,
          voucherId: this.queryObj.id,
          voucherType: 1,
        };
        this.$store.state.isLoding = true;
        operatePass(params).then((res) => {
          if (res.code == 200) {
            this.$message.success("审核不通过");
            // this.getBillDetails()
            this.$store.state.isLoding = false;
            this.$store.state.closePath = this.$route.fullPath;
          } else {
            this.$message.warn(res.logMessage);
          }
        });
      } else if (this.btnIndex == 22) {
      } else if (this.btnIndex == 23) {
      }
    },
    //撤销草稿
    btnOkSave(index) {
      if (index == 3) {
        let data = new FormData();
        data.append(
          "companyStoreId",
          this.$store.state.userInfo.companyStoreId
        );
        data.append("voucherEntityId", this.queryObj.voucherEntityId);
        updateauditState(data).then((res) => {
          if (res.success) {
            // this.$store.state.closePath = this.$route.fullPath
            this.$message.success(res.logMessage);
            this.$router.push({
              path:
                "/purchase/purchaseasmin/purchaseEnterWarehouseEdit?id=" +
                this.queryObj.voucherEntityId,
            });
          } else {
            this.$message.warn(res.logMessage);
          }
        });
      }
    },
    // 废弃
    onDeleteOrder(record, index) {
      let data = new FormData();
      data.append("companyStoreId", this.$store.state.userInfo.companyStoreId);
      data.append("voucherEntityId", this.queryObj.voucherEntityId);
      this.$store.state.isLoding = true;
      abandonstate(data, {}, {}).then((res) => {
        if (res.success) {
          this.$store.state.closePath = this.$route.fullPath;
          this.$message.success(res.logMessage);
        } else {
          this.$message.warn(res.logMessage);
        }
        this.$store.state.isLoding = false;
      });
    },
  },
};
</script>

<style lang="scss">
.bill-purchase-page {
  height: calc(100vh - 200px);
  .bill-purchase-information {
    padding: 15px 40px;
    background-color: #ffffff;
    .ant-row-one {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
    .ant-row-two {
      padding: 8px 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .ant-col {
        padding-right: 80px;
      }
    }
    .border-color {
      // width: 80px !important;
      // height: 32px !important;
      // border-radius: 6px;
      // margin: 3px 0;
      // color: #f76f14;
      // font-size: 14px;
      // line-height: 32px !important;
      color: #f76f14;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .bill-purchase-table {
    background-color: #ffffff;
    margin: 16px 0;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .text-overflow {
          width: 100%;
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
  .bill-purchase-price {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 0 40px;
    margin-top: 16px;
    .logistics-information {
      height: 132px;
      padding: 12px 0;
      display: flex;
      flex-direction: column;
      .ant-row {
        display: flex;
        padding: 12px 0;
      }
    }
    .price-information {
      height: 132px;
      padding: 12px 0;
      display: flex;
      flex-direction: column;
      .ant-row {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        padding: 12px 0;
        .ant-col {
          margin-left: 42px;
        }
        .price-color {
          font-size: 16px;
          color: #f76f14;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
